import { rankItems } from "../../../mocks/hotNews";
import SectionHeading from "./SectionHeading";

function trendBadge(change: number) {
  if (change > 0)
    return (
      <span className="flex h-6 w-6 items-center justify-center rounded-md bg-accent-100 text-accent-700">
        <i className="ri-arrow-up-line text-xs"></i>
      </span>
    );
  if (change < 0)
    return (
      <span className="flex h-6 w-6 items-center justify-center rounded-md bg-secondary-200 text-secondary-800">
        <i className="ri-arrow-down-line text-xs"></i>
      </span>
    );
  return (
    <span className="flex h-6 w-6 items-center justify-center rounded-md bg-background-200 text-foreground-600">
      <i className="ri-arrow-right-line text-xs"></i>
    </span>
  );
}

const rankColors = [
  "bg-accent-500 text-foreground-950",
  "bg-primary-500 text-background-50",
  "bg-secondary-400 text-foreground-950",
];

export default function HotRank() {
  return (
    <section id="rank" className="w-full bg-background-100/60 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1320px] px-4 md:px-6">
        <SectionHeading
          eyebrow="实时热度榜"
          title="此刻全网都在围观什么"
          desc="公开讨论量实时汇总，箭头表示热度较上一时段的升降，实时更新、随时洗牌。"
          action={
            <span className="flex items-center gap-2 whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-4 py-2 text-xs font-medium text-foreground-600">
              <span className="h-2 w-2 animate-pulse rounded-full bg-primary-500"></span>
              每 5 分钟更新
            </span>
          }
        />
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          {rankItems.map((r, i) => (
            <a
              key={r.id}
              href="#crowd"
              className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200"
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl font-display text-lg ${
                  i < 3 ? rankColors[i] : "bg-background-200 text-foreground-700"
                }`}
              >
                {i + 1}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 text-[11px]">
                  <span className="rounded-md bg-primary-100 px-2 py-0.5 font-medium text-primary-700">{r.category}</span>
                  <span className="text-foreground-500">{r.heat}</span>
                </div>
                <h3 className="mt-1 line-clamp-1 text-sm font-bold text-foreground-900 group-hover:text-primary-700 md:text-base">
                  {r.title}
                </h3>
              </div>
              {trendBadge(r.change)}
              <span className="hidden text-xs font-medium text-foreground-500 sm:block">
                升 {r.change > 0 ? `+${r.change}` : r.change === 0 ? "—" : `${r.change}`}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}